// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Afghanistan from '../_raw/flag/icon_flag_afghanistan.png';

export default () => <img src={Afghanistan} alt="Afghanistan" />;
